import { fetchEditorQuotes } from './fetchEditorQuotes';
import $ from 'jquery';
import { loadSelectQuotesCategories } from './loadSelectQuotesCategories';

export const addHtmlInputQuote = async () => {
  const html = `<div id="input-quote">
                      <textarea
                          placeholder="Scrivi il testo"
                          id="editor-add-quote-value"
                          class="mt-3 mb-3 form-control-editor editor-sidebar-item-container input-control-editor"
                      ></textarea>
                  </div>
                  <select id="select-categories-create-quote"></select>
                  <div class="sidebar-box-btns-area">
                      <button id="button-clean-html-quotes" class="buttonSidebarLeft buttonSidebarDanger">Cancella</button>
                      <button id="button-save-quote" class="buttonSidebarLeft buttonSidebarLeftSuccess">
                          <span>Salva</span>
                          <div id="editor-btn-spinner-quotes" class="spinner-grow spinner-grow-sm text-light" role="status" style="display: none;">
                              <span class="sr-only">Salvataggio in corso</span>
                          </div>
                      </button>
                  </div>
                  `;
  $('#input-add-quote').html(html);
  const { quotes } = await fetchEditorQuotes(false);
  loadSelectQuotesCategories({
    select: '#select-categories-create-quote',
    categories: Object.keys(quotes.items),
    allowCreateCategory: true,
    lastSelectedCategory: $('#select-categories-create-quote').val(),
  });
  $('#input-quote')
    .on('change keyup keydown paste cut', 'textarea', (event) => {
      $(event.currentTarget).height(0).height(event.currentTarget.scrollHeight);
    })
    .find('textarea')
    .change()
    .focus();
  $('#editor-sidebar-quotes').hide();
  $('#select-categories-container').hide();
  $('#input-filter-quotes').parent().hide();
};
